import OrderTrackingTable from "@/components/OrderTrackingTable/orderTrackingTable.component";
import BasePage from "@/infrastructure/BasePage/basePage.component";
import React from "react";
import { useTranslation } from "react-i18next";

type PageOrderTrackingProps = {
  // TODO: add props here
};

const PageOrderTracking: React.FC<PageOrderTrackingProps> = (props) => {
  const { t } = useTranslation();
  return (
    <BasePage currPage="orderTracking">
      <div className="h-full overflow-y-auto">
        <h1 className="text-center text-3xl font-bold">
          {t("Order Management")}
        </h1>
        <OrderTrackingTable />
      </div>
    </BasePage>
  );
};

export default PageOrderTracking;
